import SpineWrapper from '@Core/Animation/SpineWrapper';
import { CurrencyUtils } from '@Core/Currencies/CurrencyUtils';
import { TextContainer } from '@Core/TextContainer/TextContainer';
import { CURRENCY_TO_BITMAP_CHARACTERS } from '@Core/Utils/CurrencyCharacterUtils';
import { EGameStoreKeys } from '@GameStore/GameStoreSchema';
import { GameScene } from '..';

export class StaticJackpotMaxWinText {
    public static readonly STATIC_JACKPOT_MAX_WIN_VALUE_PLACEHOLDER = 'jackpot_value_placeholder';
    private readonly textContainer: TextContainer;
    constructor(
        private readonly scene: GameScene,
        spine: SpineWrapper,
        private readonly maxWinBetMultiplier: number
    ) {
        const text = this.getText(this.getCurrentBet(), this.maxWinBetMultiplier);
        this.textContainer = TextContainer.fromSlot(StaticJackpotMaxWinText.STATIC_JACKPOT_MAX_WIN_VALUE_PLACEHOLDER, scene, text);
        spine.slotManager.assignObjectToSlot(StaticJackpotMaxWinText.STATIC_JACKPOT_MAX_WIN_VALUE_PLACEHOLDER, this.textContainer);
        scene.game.gameStore.on(EGameStoreKeys.BetState, this.updateText, this);
    }

    private updateText() {
        this.textContainer.setText(this.getText(this.getCurrentBet(), this.maxWinBetMultiplier));
    }

    private getText(bet: number, betMultiplier: number): string {
        const value = bet * betMultiplier;
        return CurrencyUtils.formatRawCurrencyValue(value, {
            symbol: `${String.fromCodePoint(CURRENCY_TO_BITMAP_CHARACTERS[CurrencyUtils.getCurrencyISO()])}`
        });
    }

    private getCurrentBet() {
        return this.scene.game.gameStore.get(EGameStoreKeys.BetState).value.raw;
    }
}
